import { lazy } from 'react';
import ProtectedRoute from '../ProtectedRoute';
import { CompaniesCompanyAddEdit } from '@features/legal-entity-add-edit';
import { CompaniesContactPersonAddEdit } from '@features/contact-person-add-edit';
import { CompaniesEmployeeEdit } from '@features/employee-edit';
import Company from '../../../pages/Companies/Company';

//   () =>
//     import(
//       '../../components/modules/CompaniesContactPersonAddEdit/CompaniesContactPersonAddEdit.jsx'
//     )
// );
// const CompanyView = lazy(
//   () => import('../../components/modules/CompanyView/CompanyView')
// );
const Companies = lazy(() => import('../../../pages/Companies/Companies'));

export const companies_routes = [
  {
    path: 'companies',
    element: (
      <ProtectedRoute
        action={'view'}
        subject={'company'}
        redirectTo={'/'}
        children={<Companies />}
      />
    ),
    loader: () => {
      return (document.title = 'Клиенты');
    },
  },
  {
    path: 'company/:companyId?',
    element: <Company />,
    loader: () => {
      return (document.title = 'Компания');
    },
  },
  {
    // Этот «маршрут» по факту мёртвый: react-router не парсит
    // querystring через `path` (`?active_tab=:activeTab` никогда не
    // совпадёт). Оставляю элемент защищённым — на случай, если когда-то
    // переедем на правильную форму через searchParams: гейтим тем же
    // правом, что и основной `/companies`.
    path: 'companies?active_tab=:activeTab',
    element: (
      <ProtectedRoute
        action={'view'}
        subject={'company'}
        redirectTo={'/'}
        children={<Companies />}
      />
    ),
  },
  // {
  //   path: 'companies/:id',
  //   element: <CompanyView />,
  // },
  {
    path: 'company/:companyId?/legal-entities/:legalEntityId',
    element: (
      <ProtectedRoute
        action={'change'}
        subject={'legalentity'}
        redirectTo={'/companies'}
        children={<CompaniesCompanyAddEdit />}
      />
    ),
  },
  {
    path: 'company/:companyId?/contact-person/:contactPersonId',
    element: (
      <ProtectedRoute
        action={'change'}
        subject={'contact'}
        redirectTo={'/companies'}
        children={<CompaniesContactPersonAddEdit />}
      />
    ),
  },
  {
    path: 'company/:companyId?/employee/:employeeId',
    element: (
      <ProtectedRoute
        action={'editemployee'}
        subject={'username'}
        redirectTo={'/companies'}
        children={<CompaniesEmployeeEdit />}
      />
    ),
  },
  {
    path: 'company/:companyId?/legal-entities',
    element: (
      <ProtectedRoute
        action={'add'}
        subject={'legalentity'}
        redirectTo={'/companies'}
        children={<CompaniesCompanyAddEdit />}
      />
    ),
  },
  {
    path: 'company/:companyId?/contact-person',
    element: (
      <ProtectedRoute
        action={'add'}
        subject={'contact'}
        redirectTo={'/companies'}
        children={<CompaniesContactPersonAddEdit />}
      />
    ),
  },
];
